/*
 * text-effects.js · Efectos de texto (adaptados de text-effects.colorion.co) que necesitan
 * ENVOLVER el DOM. Los efectos puros-CSS (Neon-Haus, Redactor, Phosphor) viven solo en style.css.
 * Aquí van los dos que requieren estructura:
 *   · RANSOM-NOTE → "MI TRABAJO" (.portafolio-titulo): una <b> por letra, con --i para el stagger.
 *   · TELETYPE    → cita de Reguillo (.cita p): una <span> por palabra, revelada al entrar en viewport.
 *
 * HALL-A: el texto queda SIEMPRE legible (aria-label en el título; en reduced-motion todo visible ya).
 * SEGURIDAD: solo re-envuelve texto ESTÁTICO del propio index.html (NO contenido del CMS); usa
 * textContent, nunca innerHTML.
 */
import { gsap } from 'gsap';

const reducido = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

/* RANSOM-NOTE — cada letra en una caja recortada y desalineada (fanzine punk). */
function mountRansom() {
  const h = document.querySelector('.portafolio-titulo');
  if (!h || h.dataset.fx) return;
  const texto = h.textContent.trim();
  h.dataset.fx = 'ransom';
  h.setAttribute('aria-label', texto); // el lector lee "Mi trabajo", no letra a letra

  const wrap = document.createElement('span');
  wrap.className = 'fx-ransom';
  wrap.setAttribute('aria-hidden', 'true');

  let i = 0;
  for (const ch of texto) {
    const b = document.createElement('b');
    if (ch === ' ') {
      b.className = 'fx-sp'; // espacio entre palabras (sin caja ni animación)
    } else {
      b.style.setProperty('--i', String(i++)); // stagger de la oscilación
      b.textContent = ch;
    }
    wrap.appendChild(b);
  }
  h.textContent = '';
  h.appendChild(wrap);
}

/* TELETYPE — la cita se parte en palabras y se revela como teletipo al entrar en viewport. */
function mountTeletype() {
  const p = document.querySelector('.cita p');
  if (!p || p.dataset.fx) return;
  p.dataset.fx = 'teletype';

  const palabras = p.textContent.trim().split(/\s+/);
  p.textContent = '';
  p.classList.add('fx-tw');
  const spans = palabras.map((w) => {
    const s = document.createElement('span');
    s.className = 'fx-tw-w';
    s.textContent = w + ' ';
    p.appendChild(s);
    return s;
  });

  // reduced-motion: sin revelado, todo visible de una (el cursor lo apaga el CSS).
  if (reducido()) { p.classList.add('fx-tw-done'); return; }

  const reveal = () =>
    gsap.to(spans, {
      opacity: 1, duration: 0.02, ease: 'none', stagger: 0.042,
      onComplete: () => p.classList.add('fx-tw-done'), // apaga el cursor al terminar
    });

  const io = new IntersectionObserver(
    (entries, obs) => {
      for (const e of entries) if (e.isIntersecting) { reveal(); obs.disconnect(); }
    },
    { threshold: 0.5 }
  );
  io.observe(p);
}

/** Monta los efectos de texto que envuelven el DOM. Idempotente (marca con data-fx). */
export function mountTextEffects() {
  mountRansom();
  mountTeletype();
}
